import { render, staticRenderFns } from "./vault-list-skeleton.vue?vue&type=template&id=23b8f2c4"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports